var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedInColored = function SvgLinkedInColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18 2.316c0 1.06-.755 1.92-1.687 1.92S.806 3.376.806 2.316 1.561.396 2.493.396s1.687.86 1.687 1.92Zm.014 3.455H.792v12.285h3.402V5.771Zm5.428 0h-3.38v12.285h3.38v-6.45c0-3.585 4.102-3.877 4.102 0v6.45h3.395v-7.778c0-6.05-6.068-5.827-7.497-2.848V5.77Z",
    fill: "#5D5BEA"
  })));
};
export default SvgLinkedInColored;